
@if (isLoading | async) {
  <div class="loading-overlay">
    <div class="fx-column x-center y-center">
      <mat-spinner />
    </div>
  </div>
}
